
import {
  MDBCol,
  MDBRow,
  MDBContainer,
  MDBIcon,
} from 'mdb-react-ui-kit';

function Contact() {


  return (
    
    <div style={{ textAlign: "center", backgroundColor: "#F2A541", minHeight: "200px", paddingTop: "20px" }}>
      <h2 style={{ color: "rgba(48, 62, 96, 1)", fontFamily: "Consolas, monospace" }}>Contact</h2>
      <div style={{
              width: '90%',  // Largeur de la barre verticale
              marginLeft: "5%",
              height: '3px',  // Hauteur de la barre
              backgroundColor: 'rgba(48, 62, 96, 1)'
            }}></div>
      <MDBContainer fluid className="d-flex flex-column justify-content-center h-100">
        <MDBRow className="align-items-center">
          
          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginTop: "20px"}}>
            <MDBIcon fas icon="fa-solid fa-envelope" size="2x" className="me-2" />
            <h6 style={{ color: "rgba(48, 62, 96, 1)", fontFamily: "Consolas, monospace", marginTop: "8px" }}>sh.courseaularge@gmail.com</h6>
          </MDBCol>

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginTop: "20px"}}>
            <a href="https://www.facebook.com/profile.php?id=61566151288118" 
              target="_blank" 
              rel="noopener noreferrer"
              className="d-flex align-items-center">
              <MDBIcon fab icon="facebook" size="2x" className="me-2" style={{ color: "rgba(48, 62, 96, 0.9)"}}/>
              <h6 style={{ color: "rgba(48, 62, 96, 1)", fontFamily: "Consolas, monospace", marginTop: "8px" }} >SH course au large - mini 650</h6>
            </a>
          </MDBCol>

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginTop: "20px"}}>
            <a href="https://www.instagram.com/sh_course_au_large_mini650/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="d-flex align-items-center">
              <MDBIcon fab icon="instagram" size="2x" className="me-2" style={{ color: "rgba(48, 62, 96, 0.9)"}}/>
              <h6 style={{ color: "rgba(48, 62, 96, 1)", fontFamily: "Consolas, monospace", marginTop: "8px" }} >sh_course_au_large_mini650</h6>
            </a>
          </MDBCol>

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginTop: "20px"}}>
            <MDBIcon fas icon="fa-solid fa-phone" size="lg" className="me-2"/>
            <h6 style={{ color: "rgba(48, 62, 96, 1)", fontFamily: "Consolas, monospace", marginTop: "8px" }}>06 52 61 06 79 / 06 95 61 21 04</h6>
          </MDBCol>

        </MDBRow>
      </MDBContainer>
    </div>


  );
}

export default Contact;